import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=0ccd8a9e&scoped=true"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"
import style0 from "./ChatInput.vue?vue&type=style&index=0&id=0ccd8a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccd8a9e",
  null
  
)

export default component.exports